import React from "react"
import L from 'leaflet'
import axios from 'axios'
import {Map, Marker, Popup, TileLayer} from 'react-leaflet'


class Map1 extends React.Component {
    constructor(props){
        super(props);
        this.state={
            lat: 0,
            long: 0,
            zoom: 5,
            defaultlat: 0,
            defaultlong: 0,
        }
    }
    componentWillMount() {
      axios.get('https://api.wheretheiss.at/v1/satellites/25544')
     .then( res => {this.setState({defaultlat : res.data.latitude, defaultlong : res.data.longitude})})
     .catch(err => console.log(err))
    }

   componentDidMount() {
  
    this.interval = setInterval(() => {
      axios.get('https://api.wheretheiss.at/v1/satellites/25544')
     .then( res => {this.setState({lat : res.data.latitude, long : res.data.longitude})})
     .catch(err => console.log(err))
    }, 7000);
    
     
    }
      
   
    render(){
      let numLat= (this.state.lat).toFixed(4)
      let numLong= (this.state.long).toFixed(4)
        const position= [this.state.lat, this.state.long]
        const firstView= [this.state.defaultlat, this.state.defaultlong] 
        const icon= L.icon({
            iconUrl: require("./../img/ICONMarker.png"),
            iconSize: [50,50],
            iconAnchor: [25,25],
        })
    return(
    <>
      <div id="homeContainer" className='iframesContainer'>
        <img alt="" className="background" src="https://img.20mn.fr/LutumfnnRlyGBwERhRjNrw/640x410_planete-terre.jpg"/>

          <Map className="map" center={firstView} zoom={this.state.zoom}>
          <p className='mapStatistics'>latitude : {numLat}° <br/> longitude : {numLong}°</p>
          <TileLayer
            url="https://stamen-tiles-{s}.a.ssl.fastly.net/terrain-background/{z}/{x}/{y}{r}.png"
            attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
          />
          <TileLayer
            url="https://stamen-tiles-{s}.a.ssl.fastly.net/terrain-labels/{z}/{x}/{y}{r}.png"
          />
          <Marker icon={icon}position={position}>
            <Popup>ISS is HERE</Popup>
          </Marker>
        </Map>

      </div>
      </>
    )
}
}
export default Map1;

// utilise geocode dans Arty, où tu compare les donnés avec géocodes, puis tu affecte cela à un bouton (ou autre?) puis tu essyae de l'utiliser avec ta commande vocal